import React, { useEffect } from "react";
import svg62 from "../../../assets/svg/svg62.svg";
import expandedSvg from "../../../assets/img/expanded.png";
import highPerfSvg from "../../../assets/img/public.png";
import asalSvg from "../../../assets/img/asal.png";
import corporateSvg from "../../../assets/img/corporate.png";
import communitySvg from "../../../assets/img/community.png";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { useDispatch, useSelector } from "react-redux";
import { setActiveObj } from "../../../features/obj/objSlice";
import CardLoading from "../../../components/CardLoading";


function PathwayCards() {
  const url = "api/v2/irrigationPathway/fetchIrrigationPathwaysSummery";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const handleCardClick = async (item) => {
    await dispatch(setActiveObj({ key: "pathwayCard", data: item }));
    await navigate(item?.link ?? null);
  };


    const svgMap = {
      expandedSvg,
      highPerfSvg,
      asalSvg,
      corporateSvg,
      communitySvg,
    };
    const processedData = data?.map((item) => ({
      ...item,
      icon: svgMap[item?.icon],
    }));

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
      })
    );
  }
 
  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading) return <CardLoading />;
  return (
    <div className="">
      <div className="form-add-h">SDI Pathways</div>
      <div className="mt-[1rem] grid lg:grid-cols-3 grid-cols-1 gap-[1.75rem]">
        {processedData &&
          processedData?.map((item) => (
            <div
              className="border border-[#D6E1F5] cursor-pointer bg-white rounded-[.75rem]   w-full  p-[1rem] flex flex-col justify-between"
              onClick={() => handleCardClick(item)}
            >
              <div className="flex justify-between items-center paragraph_paragraph_bb13 !font-[500]">
                <div className="flex items-start  gap-[.5rem]">
                  <img className="w-[45px] h-[45px]" src={item?.icon} alt={item?.icon}/>
                  <span className="inline-block max-w-[160px] break-words whitespace-normal">
                  {" "}
                  {item?.irrigationPathwayName}
                </span>
                </div>
                
                <span className="bg-[#F1F3F5] h-[1.5rem] w-[1.5rem] rounded-full flex items-center justify-center">
                  <img src={svg62} alt="svg62" />
                </span>
              </div>

              <div className="flex items-center flex-wrap gap-[.5rem] mt-auto pt-[1rem]">
                {["sub1", "sub2", "sub3", "sub4"]?.map((sub, index) => {
                  const value = item?.[sub];
                  return value ? (
                    <div
                      key={index}
                      className="bg-[#F1F3F5] rounded-[.25rem] py-[.25rem] px-[.3125rem] text-[#424242] font-[400] text-[.75rem] font-interSans"
                    >
                      {value}
                    </div>
                  ) : null;
                })}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default PathwayCards;
